export default function isInViewport(element) {
	const _el = $(element).get(0);
	const boundingBox = _el.getBoundingClientRect();

	if (boundingBox.top >= 0
		&& boundingBox.left >= 0
		&& boundingBox.right <= (window.innerWidth || document.documentElement.clientWidth)
		&& boundingBox.bottom <= (window.innerHeight || document.documentElement.clientHeight))
	{

		return true;
	} else {
		return false;
	}
}